import styled from 'styled-components'
import colors from '../../../../configuration/colors'
import CopySvg from '../../../../static/images/icons/copy.svg'
import EditSvg from '../../../../static/images/icons/edit_icon.svg'
import SkillsSvg from '../../../../static/images/Skills/skills_icon_large.svg'
import DeleteIcon from '../../../../static/images/icons/close_btn_normal_light.svg'
import FlexAlignCenter from '../../../styled/FlexAlignCenter'
import { H3, H5, Caption1 } from '../../../styled/typography/typography'

export const DeleteWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: -16px;
  right: -88px;
  height: 100%;
  width: 70px;
`

export const DeleteButton = styled.div`
  height: 32px;
  width: 32px;
  background: 50% ${colors.white} no-repeat url(${DeleteIcon});
  background-size: 14px 14px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  border-radius: 33px;
  cursor: pointer;
`

export const CopyIcon = styled.img.attrs({
  src: CopySvg
})`
  position: absolute;
  right: 15px;
  bottom: 15px;
  width: 22px;
  height: 22px;
  cursor: pointer;
`

export const EditIcon = styled.img.attrs({
  src: EditSvg
})`
  width: 13px;
  height: 13px;
  margin-left: 14px;
  cursor: pointer;
`

export const SkillsIcon = styled.img.attrs({
  src: SkillsSvg
})`
  width: 32px;
  height: 24px;
`

export const InnerWhiteWrapper = styled(FlexAlignCenter)`
  position: relative;
  height: auto;
  width: 100%;
  background: ${props =>
    props.displayWhite ? props.theme.lightSkillBackground : props.theme.skillBackground};
`

export const InnerTransparentWrapper = styled(FlexAlignCenter)`
  position: relative;
  height: auto;
  width: 100%;
  cursor: pointer;
`

export const Wrapper = styled(FlexAlignCenter)`
  height: auto;
  width: 100%;
  margin: 25px 0;
  padding: 17px 30px;
  background: ${props => props.theme.skillBackground};

  .delete-focus-skill {
    display: none;
  }

  &:hover {
    .delete-focus-skill {
      display: block;
    }
  }
`

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`

export const Diamond = styled.div`
  height: 16px;
  width: 16px;
  border-radius: 2px;
  border: 1px solid ${colors.silver};
  transform: rotate(45deg);
  background: ${colors.ash};
  transition: background-color 0.3s ease-in-out;
`

export const GuidanceWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 14px 17px 30px;
  margin-top: 12px;
  min-height: 94px;
  border-radius: 12px;
  border: 1px solid ${colors.rock};
  background: ${colors.white};
  z-index: ${props => (props.focus ? '20' : '0')};
`

export const OrderedList = styled.ol`
  width: 100%;
  padding: 0;
  margin: 15px 0 0;

  &.focus-skill-guidance-list {
    .focus-skill-guidance-delete-button {
      display: none;
    }

    &:hover {
      .focus-skill-guidance-delete-button {
        display: block;
      }
    }
  }
`

export const FocusSkillGuidance = styled(Caption1)`
  color: ${colors.charcoal4};
`

export const CancelButton = styled(H5).attrs({
  as: 'button'
})`
  margin-right: 20px;
  background: none;
  border: none;
`

export const Caption1MutateFocusSkill = styled(Caption1).attrs({
  as: 'caption'
})`
  margin-top: 5px;
`
